import CommonRadioMulSelect from '../CommonRadioMulSelect';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum ESubscribed {
  YES = 'YES',
  NO = 'NO',
}
const Subscription = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, noStyle, disabled } = props;
  return (
    <CommonRadioMulSelect
      triggerName={[]}
      radioOptions={[
        { value: ESubscribed.YES, label: getI18n('general.status.subscribed') },
        {
          value: ESubscribed.NO,
          label: getI18n('general.status.notsubscribed'),
        },
      ]}
      radioName={radioName}
      noStyle={noStyle}
      disabled={disabled}
    />
  );
};
export default Subscription;
